import {axiosBackendAPI} from "@/lib/axios";
import {backendAPIRoutes} from "@/lib/routes";
import { v2Api } from "@/lib/api";
import type { TReportDetailItem } from "@/types/reports";

export const ReportServices = {
    getReportById : async (reportId: string): Promise<TReportDetailItem> => {
        const isServer = typeof window === 'undefined';
        if (isServer) {
            const res = await axiosBackendAPI.get(backendAPIRoutes.dashboard.reports.detail(reportId));
            return res.data;
        }
        return v2Api.reports.detail(reportId);
    }
}